// extracted by mini-css-extract-plugin
export default {"form":"TaskForm_form__itmOW","input_container":"TaskForm_input_container__++mIo"};